import { MusicNote, Visibility, Mic, Album } from "@mui/icons-material";
import scalettaFinale from "./scaletta_finale.json";

export const categories = [
  {
    id: "canzone",
    key: "canzone",
    label: "Canzone",
    icon: <MusicNote />,
    color: "#E91E63",
    max: 10,
    description: "Composizione, testo e arrangiamento",
  },
  {
    id: "presenza_scenica",
    key: "presenza_scenica",
    label: "Outfit",
    icon: <Visibility />,
    color: "#9C27B0",
    max: 5,
    description: "Look, stile e capacità di tenere il palco",
  },
  {
    id: "esibizione",
    key: "esibizione",
    label: "Esibizione",
    icon: <Mic />,
    color: "#2196F3",
    max: 5,
    description: "Qualità vocale e interpretazione",
  },
  {
    id: "canzone_cover",
    key: "canzone_cover",
    label: "Cover",
    icon: <Album />,
    color: "#FF9800",
    max: 5,
    description: "Valutazione della cover e del duetto (solo Serata Cover)",
  },
];

export const songs = [
  {
    key: "song1",
    country: "Arisa",
    artist: "Arisa",
    title: "Magica favola",
    order: 1,
    image: "song1.jpg",
    cover: {
      title: "Quello che le donne non dicono",
      guest: "Coro del Teatro Regio di Parma",
      original: "Fiorella Mannoia - 1987",
    },
  },
  {
    key: "song2",
    country: "Bambole di pezza",
    artist: "Bambole di pezza",
    title: "Resta con me",
    order: 2,
    image: "song2.avif",
    cover: {
      title: "Occhi di gatto",
      guest: "Cristina D'Avena",
      original: "Cristina D'Avena - 1985",
    },
  },
  {
    key: "song3",
    country: "Chiello",
    artist: "Chiello",
    title: "Ti penso sempre",
    order: 3,
    image: "song3.avif",
    cover: {
      title: "Mi sono innamorato di te",
      guest: "Saverio Cigarini",
      original: "Luigi Tenco - 1962",
    },
  },
  {
    key: "song4",
    country: "Dargen D'Amico",
    artist: "Dargen D'Amico",
    title: "Ai ai",
    order: 4,
    image: "song4.webp",
    cover: {
      title: "Su di noi",
      guest: "Pupo e Fabrizio Bosso",
      original: "Pupo - 1980",
    },
  },
  {
    key: "song5",
    country: "Ditonellapiaga",
    artist: "Ditonellapiaga",
    title: "Che Fastidio!",
    order: 5,
    image: "song5.avif",
    cover: {
      title: "The Lady Is a Tramp",
      guest: "TonyPitony",
      original: "Mitzi Green - 1937",
    },
  },
  {
    key: "song6",
    country: "Eddie Brock",
    artist: "Eddie Brock",
    title: "Avvoltoi",
    order: 6,
    image: "song6.avif",
    cover: {
      title: "Portami via",
      guest: "Fabrizio Moro",
      original: "Fabrizio Moro - 2017",
    },
  },
  {
    key: "song7",
    country: "Elettra Lamborghini",
    artist: "Elettra Lamborghini",
    title: "Voilà",
    order: 7,
    image: "song7.webp",
    cover: {
      title: "Aserejé",
      guest: "Las Ketchup",
      original: "Las Ketchup - 2002",
    },
  },
  {
    key: "song8",
    country: "Enrico Nigiotti",
    artist: "Enrico Nigiotti",
    title: "Ogni volta che non so volare",
    order: 8,
    image: "song8.avif",
    cover: {
      title: "En e Xanax",
      guest: "Alfa",
      original: "Samuele Bersani - 2013",
    },
  },
  {
    key: "song9",
    country: "Ermal Meta",
    artist: "Ermal Meta",
    title: "Stella stellina",
    order: 9,
    image: "song9.avif",
    cover: { title: "Golden Hour", guest: "Dardust", original: "Jvke - 2022" },
  },
  {
    key: "song10",
    country: "Fedez e Marco Masini",
    artist: "Fedez e Marco Masini",
    title: "Male necessario",
    order: 10,

    image: "song10.avif",
    cover: {
      title: "Meravigliosa creatura",
      guest: "Stjepan Hauser",
      original: "Gianna Nannini - 1995",
    },
  },
  {
    key: "song11",
    country: "Francesco Renga",
    artist: "Francesco Renga",
    title: "Il meglio di me",
    order: 11,
    image: "song11.avif",
    cover: {
      title: "Ragazzo solo, ragazza sola",
      guest: "Giusy Ferreri",
      original: "David Bowie - 1970",
    },
  },
  {
    key: "song12",
    country: "Fulminacci",
    artist: "Fulminacci",
    title: "Stupida sfortuna",
    order: 12,
    image: "song12.avif",
    cover: {
      title: "Parole parole",
      guest: "Francesca Fagnani",
      original: "Mina e Alberto Lupo - 1972",
    },
  },
  {
    key: "song13",
    country: "J-Ax",
    artist: "J-Ax",
    title: "Italia Starter Pack",
    order: 13,
    image: "song13.avif",
    cover: {
      title: "E la vita, la vita",
      guest: "Ligera County Fam.",
      original: "Cochi e Renato - 1974",
    },
  },
  {
    key: "song14",
    country: "LDA e AKA 7even",
    artist: "LDA e AKA 7even",
    title: "Poesie clandestine",
    order: 14,
    image: "song14.avif",
    cover: {
      title: "Andamento lento",
      guest: "Tullio De Piscopo",
      original: "Tullio De Piscopo - 1988",
    },
  },
  {
    key: "song15",
    country: "Leo Gassmann",
    artist: "Leo Gassmann",
    title: "Naturale",
    order: 15,
    image: "song15.avif",
    cover: {
      title: "Era già tutto previsto",
      guest: "Aiello",
      original: "Riccardo Cocciante - 1975",
    },
  },
  {
    key: "song16",
    country: "Levante",
    artist: "Levante",
    title: "Sei tu",
    order: 16,
    image: "song16.jpg",
    cover: {
      title: "I maschi",
      guest: "Gaia",
      original: "Gianna Nannini - 1987",
    },
  },
  {
    key: "song17",
    country: "Luchè",
    artist: "Luchè",
    title: "Labirinto",
    order: 17,
    image: "song17.jpg",
    cover: {
      title: "Falco a metà",
      guest: "Gianluca Grignani",
      original: "Gianluca Grignani - 1995",
    },
  },
  {
    key: "song18",
    country: "Malika Ayane",
    artist: "Malika Ayane",
    title: "Animali notturni",
    order: 18,
    image: "song18.avif",
    cover: {
      title: "Mi sei scoppiato dentro il cuore",
      guest: "Claudio Santamaria",
      original: "Mina - 1966",
    },
  },
  {
    key: "song19",
    country: "Mara Sattei",
    artist: "Mara Sattei",
    title: "Le cose che non sai di me",
    order: 19,
    image: "song19.avif",
    cover: {
      title: "L'ultimo bacio",
      guest: "Mecna",
      original: "Carmen Consoli - 2000",
    },
  },
  {
    key: "song20",
    country: "Maria Antonietta e Colombre",
    artist: "Maria Antonietta e Colombre",
    title: "La felicità e basta",
    order: 20,
    image: "song20.avif",
    cover: {
      title: "Il mondo",
      guest: "Brunori Sas",
      original: "Jimmy Fontana - 1965",
    },
  },
  {
    key: "song21",
    country: "Michele Bravi",
    artist: "Michele Bravi",
    title: "Prima o poi",
    order: 21,
    image: "song21.avif",
    cover: {
      title: "Domani è un altro giorno",
      guest: "Fiorella Mannoia",
      original: "Ornella Vanoni - 1971",
    },
  },
  {
    key: "song22",
    country: "Nayt",
    artist: "Nayt",
    title: "Prima che",
    order: 22,
    image: "song22.jpg",
    cover: {
      title: "La canzone dell'amore perduto",
      guest: "Joan Thiele",
      original: "Fabrizio De André - 1966",
    },
  },
  {
    key: "song23",
    country: "Patty Pravo",
    artist: "Patty Pravo",
    title: "Opera",
    order: 23,
    image: "song23.avif",
    cover: {
      title: "Ti lascio una canzone",
      guest: "Timofej Andrijashenko",
      original: "Ornella Vanoni e Gino Paoli - 1985",
    },
  },
  {
    key: "song24",
    country: "Raf",
    artist: "Raf",
    title: "Ora e per sempre",
    order: 24,
    image: "song24.avif",
    cover: {
      title: "The Riddle",
      guest: "The Kolors",
      original: "Nik Kershaw - 1984",
    },
  },
  {
    key: "song25",
    country: "Sal Da Vinci",
    artist: "Sal Da Vinci",
    title: "Per sempre sì",
    order: 25,
    image: "song25.avif",
    cover: {
      title: "Cinque giorni",
      guest: "Michele Zarrillo",
      original: "Michele Zarrillo - 1994",
    },
  },
  {
    key: "song26",
    country: "Samurai Jay",
    artist: "Samurai Jay",
    title: "Ossessione",
    order: 26,
    image: "song26.avif",
    cover: {
      title: "Baila morena",
      guest: "Belén Rodríguez e Roy Paci",
      original: "Zucchero Fornaciari - 2001",
    },
  },
  {
    key: "song27",
    country: "Sayf",
    artist: "Sayf",
    title: "Tu mi piaci tanto",
    order: 27,
    image: "song27.avif",
    cover: {
      title: "Hit the Road Jack",
      guest: "Alex Britti e Mario Biondi",
      original: "Ray Charles - 1961",
    },
  },
  {
    key: "song28",
    country: "Serena Brancale",
    artist: "Serena Brancale",
    title: "Qui con me",
    order: 28,
    image: "song28.avif",
    cover: {
      title: "Besame mucho",
      guest: "Gregory Porter e Delia",
      original: "Andrea Bocelli - 2006",
    },
  },
  {
    key: "song29",
    country: "Tommaso Paradiso",
    artist: "Tommaso Paradiso",
    title: "I romantici",
    order: 29,
    image: "song29.avif",
    cover: {
      title: "L'ultima luna",
      guest: "Stadio",
      original: "Lucio Dalla - 1979",
    },
  },
  {
    key: "song30",
    country: "Tredici Pietro",
    artist: "Tredici Pietro",
    title: "Uomo che cade",
    image: "song30.avif",
    order: 30,
    cover: {
      title: "Vita",
      guest: "Galeffi, Fudasca & Band",
      original: "Gianni Morandi e Lucio Dalla - 1988",
    },
  },
];

export const nights = {
  1: {
    id: 1,
    label: "Prima Serata",
    scheduleKey: "prima_serata",
    filter: (song) => true,
    isCoverNight: false,
  },
  2: {
    id: 2,
    label: "Seconda Serata",
    scheduleKey: "seconda_serata",
    defaultOrder: [
      "song7",
      "song9",
      "song16",
      "song2",
      "song3",
      "song13",
      "song22",
      "song12",
      "song10",
      "song4",
      "song23",
      "song14",
      "song8",
      "song29",
      "song5",
    ],
    filter: (song) =>
      [
        "song23",
        "song14",
        "song8",
        "song29",
        "song7",
        "song9",
        "song16",
        "song2",
        "song3",
        "song13",
        "song22",
        "song12",
        "song10",
        "song4",
        "song5",
      ].includes(song.key),
    isCoverNight: false,
  },
  3: {
    id: 3,
    label: "Terza Serata",
    scheduleKey: "terza_serata",
    defaultOrder: [
      "song20",
      "song15",
      "song18",
      "song25",
      "song30",
      "song24",
      "song11",
      "song6",
      "song28",
      "song26",
      "song1",
      "song21",
      "song17",
      "song19",
      "song27",
    ],
    filter: (song) =>
      [
        "song20",
        "song15",
        "song18",
        "song25",
        "song30",
        "song24",
        "song11",
        "song6",
        "song28",
        "song26",
        "song1",
        "song21",
        "song17",
        "song19",
        "song27",
      ].includes(song.key),
    isCoverNight: false,
  },
  4: {
    id: 4,
    label: "Quarta Serata",
    scheduleKey: "quarta_serata",
    defaultOrder: [
      "song7",
      "song6",
      "song19",
      "song23",
      "song16",
      "song18",
      "song2",
      "song4",
      "song29",
      "song21",
      "song30",
      "song20",
      "song12",
      "song14",
      "song24",
      "song13",
      "song5",
      "song8",
      "song28",
      "song27",
      "song11",
      "song1",
      "song26",
      "song25",
      "song10",
      "song9",
      "song22",
      "song17",
      "song3",
      "song15",
    ],
    filter: (song) => true,
    isCoverNight: true,
  },
  5: {
    id: 5,
    label: "Finale",
    scheduleKey: "finale",
    defaultOrder: scalettaFinale.scaletta
      .filter((item) => item.key)
      .map((item) => item.key),
    filter: (song) => true,
    isCoverNight: false,
  },
};

export const eurovisionSongs = [
  {
    key: "song1",
    country: "Albania",
    tv: "RTSH",
    artist: "Alis",
    title: "Nân",
    language: "Albanian",
    order: 1,
    image: "01_Albania.jpg",
  },
  {
    key: "song2",
    country: "Armenia",
    tv: "AMPTV",
    artist: "Simón",
    title: "Paloma rumba",
    language: "English",
    order: 2,
    image: "02_Armenia.jpg",
  },
  {
    key: "song3",
    country: "Australia",
    tv: "SBS",
    artist: "Delta Goodrem",
    title: "Eclipse",
    language: "English",
    order: 3,
    image: "03_Australia.jpg",
  },
  {
    key: "song4",
    country: "Austria",
    tv: "ORF",
    artist: "Cosmó",
    title: "Tanzschein",
    language: "German",
    order: 4,
    image: "04_Austria.jpg",
  },
  {
    key: "song5",
    country: "Azerbaijan",
    tv: "İTV",
    artist: "Jiva",
    title: "Just Go",
    language: "English, Azerbaijani",
    order: 5,
    image: "05_Azerbaijan.jpg",
  },
  {
    key: "song6",
    country: "Belgio",
    tv: "RTBF",
    artist: "Essyla",
    title: "Dancing on the Ice",
    language: "English",
    order: 6,
    image: "06_Belgio.jpg",
  },
  {
    key: "song7",
    country: "Bulgaria",
    tv: "BNT",
    artist: "Dara",
    title: "Bangaranga",
    language: "English",
    order: 7,
    image: "07_Bulgaria.jpg",
  },
  {
    key: "song8",
    country: "Croazia",
    tv: "HRT",
    artist: "Lelek",
    title: "Andromeda",
    language: "Croatian",
    order: 8,
    image: "08_Croazia.jpg",
  },
  {
    key: "song9",
    country: "Cipro",
    tv: "CyBC",
    artist: "Antigoni",
    title: "Jalla",
    language: "English, Greek",
    order: 9,
    image: "09_Cipro.jpg",
  },
  {
    key: "song10",
    country: "Repubblica Ceca",
    tv: "ČT",
    artist: "Daniel Zizka",
    title: "Crossroads",
    language: "English",
    order: 10,
    image: "10_RepCeca.jpg",
  },
  {
    key: "song11",
    country: "Danimarca",
    tv: "DR",
    artist: "Søren Torpegaard Lund",
    title: "Før vi går hjem",
    language: "Danishish",
    order: 11,
    image: "11_Danimarca.jpg",
  },
  {
    key: "song12",
    country: "Estonia",
    tv: "ERR",
    artist: "Vanilla Ninja",
    title: "Too Epic to Be True",
    language: "English",
    order: 12,
    image: "12_Estonia.jpg",
  },
  {
    key: "song13",
    country: "Finlandia",
    tv: "Yle",
    artist: "Linda Lampenius and Pete Parkkonen",
    title: "Liekinheitin",
    language: "Finnish",
    order: 13,
    image: "13_Finlandia.jpg",
  },
  {
    key: "song14",
    country: "Francia",
    tv: "France Télévisions",
    artist: "Monroe",
    title: "Regarde !",
    language: "French",
    order: 14,
    image: "14_Francia.jpg",
  },
  {
    key: "song15",
    country: "Georgia",
    tv: "GPB",
    artist: "Bzikebi",
    title: "On Replay",
    language: "English",
    order: 15,
    image: "15_Georgia.jpg",
  },
  {
    key: "song16",
    country: "Germania",
    tv: "SWR",
    artist: "Sarah Engels",
    title: "Fire",
    language: "English",
    order: 16,
    image: "16_Germania.jpg",
  },
  {
    key: "song17",
    country: "Grecia",
    tv: "ERT",
    artist: "Akylas",
    title: "Ferto (Φέρτο)",
    language: "Greek",
    order: 17,
    image: "17_Grecia.jpg",
  },
  {
    key: "song18",
    country: "Israele",
    tv: "IPBC",
    artist: "Noam Bettan",
    title: "Michelle",
    language: "French, Hebrew, English",
    order: 18,
    image: "18_Israele.jpg",
  },
  {
    key: "song19",
    country: "Italia",
    tv: "RAI",
    artist: "Sal Da Vinci",
    title: "Per sempre sì",
    language: "Italian",
    order: 19,
    image: "19_Italia.jpg",
  },
  {
    key: "song20",
    country: "Lettonia",
    tv: "LSM",
    artist: "Atvara",
    title: "Ēnā",
    language: "Latvian",
    order: 20,
    image: "20_Lettonia.jpg",
  },
  {
    key: "song21",
    country: "Lituania",
    tv: "LRT",
    artist: "Lion Ceccah",
    title: "Sólo quiero más",
    language: "Lithuanian, English",
    order: 21,
    image: "21_Lituania.jpg",
  },
  {
    key: "song22",
    country: "Lussemburgo",
    tv: "RTL",
    artist: "Eva Marija",
    title: "Mother Nature",
    language: "English",
    order: 22,
    image: "22_Lussemburgo.jpg",
  },
  {
    key: "song23",
    country: "Malta",
    tv: "PBS",
    artist: "Aidan",
    title: "Bella",
    language: "English, Maltese",
    order: 23,
    image: "23_Malta.jpg",
  },
  {
    key: "song24",
    country: "Moldavia",
    tv: "TRM",
    artist: "Satoshi",
    title: "Viva, Moldova!",
    language: "Romanian",
    order: 24,
    image: "24_Moldavia.jpg",
  },
  {
    key: "song25",
    country: "Montenegro",
    tv: "RTCG",
    artist: "Tamara Živković",
    title: "Nova zora (Нова зора)",
    language: "Montenegrin",
    order: 25,
    image: "25_Montenegro.jpg",
  },
  {
    key: "song26",
    country: "Norvegia",
    tv: "NRK",
    artist: "Jonas Lovv",
    title: "Ya Ya Ya",
    language: "English",
    order: 26,
    image: "26_Norvegia.jpg",
  },
  {
    key: "song27",
    country: "Polonia",
    tv: "TVP",
    artist: "Alicja",
    title: "Pray",
    language: "English",
    order: 27,
    image: "27_Polonia.jpg",
  },
  {
    key: "song28",
    country: "Portogallo",
    tv: "RTP",
    artist: "Bandidos do Cante",
    title: "Rosa",
    language: "Portuguese",
    order: 28,
    image: "28_Portogallo.jpg",
  },
  {
    key: "song29",
    country: "Romania",
    tv: "TVR",
    artist: "Alexandra Căpitănescu",
    title: "Choke Me",
    language: "English",
    order: 29,
    image: "29_Romania.jpg",
  },
  {
    key: "song30",
    country: "San Marino",
    tv: "SMRTV",
    artist: "Senhit",
    title: "Superstar",
    language: "English",
    order: 30,
    image: "30_SanMarino.jpg",
  },
  {
    key: "song31",
    country: "Serbia",
    tv: "RTS",
    artist: "Lavina",
    title: "Kraj mene (Крај мене)",
    language: "Serbian",
    order: 31,
    image: "31_Serbia.jpg",
  },
  {
    key: "song32",
    country: "Svezia",
    tv: "SVT",
    artist: "Felicia",
    title: "My System",
    language: "English",
    order: 32,
    image: "32_Svezia.jpg",
  },
  {
    key: "song33",
    country: "Svizzera",
    tv: "SRG SSR",
    artist: "Veronica Fusaro",
    title: "Alice",
    language: "English",
    order: 33,
    image: "33_Svizzera.jpg",
  },
  {
    key: "song34",
    country: "Ucraina",
    tv: "Suspilne",
    artist: "Leléka",
    title: "Ridnym (Рідним)",
    language: "English, Ukrainian",
    order: 34,
    image: "34_Ucraina.jpg",
  },
  {
    key: "song35",
    country: "Regno Unito",
    tv: "BBC",
    artist: "Look Mum No Computer",
    title: "Eins, Zwei, Drei",
    language: "English",
    order: 35,
    image: "35_RegnoUnito.jpg",
  },
];

const eurovisionFinalKeys = Array.from(
  { length: 35 },
  (_, i) => `song${i + 1}`,
);

export const eurovisionNights = {
  1: {
    id: 1,
    label: "Finale",
    scheduleKey: "finale",
    defaultOrder: eurovisionFinalKeys,
    filter: (song) => true,
    isCoverNight: false,
  },
};

export const getEventSongsData = (eventKey = "sanremo") => {
  if (eventKey === "eurovision") {
    return { songs: eurovisionSongs, categories, nights: eurovisionNights };
  }

  return { songs, categories, nights };
};

export const eventsCatalog = [
  {
    key: "sanremo",
    title: "Sanremo 2026",
    subtitle: "Votazioni e scaletta",
    status: "Disponibile",
  },
  {
    key: "eurovision",
    title: "Eurovision",
    subtitle: "Copia di Sanremo (work in progress)",
    status: "Disponibile",
  },
];

export const isKnownEventKey = (eventKey) =>
  eventsCatalog.some((event) => event.key === eventKey);

export const getEventMeta = (eventKey) =>
  eventsCatalog.find((event) => event.key === eventKey) || null;
